import styled from "styled-components";

const AddressLookUpListStyled = styled.ul`
    border: ${props => props.theme.lightGrayBorder};
    padding-left: 0;
    position: absolute;
    background: ${props => props.theme.white};
    z-index: 100;
    top: 5.6rem;
    width: 100%;
    li {
        padding: 2rem 3rem;
        margin: 0;
        cursor: pointer;
        border-bottom: ${props => props.theme.lightGrayBorder};
        &:before {
            content: "";
        }
        &:first-child, &:hover {
            background: ${props => props.theme.lightBlue};
            color: ${props => props.theme.black};
            cursor: pointer;
        }
        .green {
            color: ${props => props.theme.lightGreen};
        }
        &.messageBox {
            background: ${props => props.theme.lightYellow};
            color: ${props => props.theme.gold};
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            .cancelAddress {
                font-weight: normal;
            }
        }

    }
`;

export default AddressLookUpListStyled;